import React from 'react';
import TituloTexto from '../../layout/titulo-texto';

const PagoMercadoPago = () => {
  const texto = (
    ''
  );
  return (
    <TituloTexto titulo='Elegiste pagar con Mercado Pago' texto={texto} />
  );
};

export default PagoMercadoPago;
